/**************************************************************************************************************************
 Copyright (c) 2024 WorkEarly Results LLP

     Name: index.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { NextUIProvider } from '@nextui-org/react';

import '@/i18next';
import TranscadOrgSite from '@/app';
import reportWebVitals from '@/reportWebVitals';
/**************************************************************************************************************************
 CSS / STYLES
***************************************************************************************************************************/
import '@/styles/global.css';
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Router>
    <React.StrictMode>
      <AnimatePresence mode="wait">
        <Suspense>
          <NextUIProvider>
            <TranscadOrgSite />
          </NextUIProvider>
        </Suspense>
      </AnimatePresence>
    </React.StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
